<!-- // WTG PRICE GRID -->
<ng-container #priceGrid *ngIf="brand?.detailPageConfig.showPriceGrid">
  <div class="detail-content mt-4 accomodation-tab__solutions">
    <detail-price-grid
      [holidayDetails]="holidayDetails">
    </detail-price-grid>
    <div class="detail-recap__row detail-recap__cta__wrapper mb-5 d-lg-none" *ngIf="(isWidget$ | async)">
      <a class="detail-recap__cta__button btn btn--brand-color-03" dynamicNavigation
         [href]="bookingUrl">
        Prosegui
      </a>
    </div>
  </div>
</ng-container>

<div class="detail-content__section accomodation-tab__tags my-4" *ngIf="holidayDetails?.tags">
  <div class="detail-content__row">
    <app-detail-content-tags [tags]="holidayDetails?.tags"></app-detail-content-tags>
  </div>
</div>

<div class="detail-content__section mb-4" *ngIf="holidayDetails?.isPacketVisible">
  <detail-content-packet [packet]="holidayDetails.packet"></detail-content-packet>
</div>

<div *ngIf="holidayDetails?.texts" class="accomodation-tab__details my-4">
  <app-detail-content-description [texts]="holidayDetails?.texts"></app-detail-content-description>
</div>

<div class="detail-content__section accomodation-tab__map" *ngIf="holidayDetails?.accomodation && !hideMapForSpecificProduct">
  <div class="detail-content__row">
    <div class="detail-content__section detail-content__map">
      <app-detail-content-map [accomodation]="holidayDetails?.accomodation"></app-detail-content-map>
    </div>
  </div>
  <hr class="dashed-border">
</div>

<div class="detail-content__section detail-content__activities accomodation-tab__activities"
  *ngIf="holidayDetails?.activities?.length">
  <app-detail-content-activities [activities]="holidayDetails?.activities"></app-detail-content-activities>
  <hr class="dashed-border">
</div>

<div class="detail-content__section detail-content__languages" *ngIf="holidayDetails?.languages?.length">
  <app-detail-content-languages [languages]="holidayDetails?.languages"></app-detail-content-languages>
  <hr class="dashed-border">
</div>

<div class="detail-content__section detail-content__facilities accomodation-tab__facilities"
  *ngIf="holidayDetails?.facilities?.length">
  <app-detail-content-facilities [facilities]="holidayDetails?.facilities"></app-detail-content-facilities>
  <hr class="dashed-border">
</div>

<div class="detail-content__section accomodation-tab__itinerary" *ngIf="holidayDetails?.tour?.itinerary">
  <div class="detail-content__row">
    <div class="detail-content__section detail-content__map">
      <app-detail-content-itinerary [itinerary]="holidayDetails?.tour?.itinerary">
      </app-detail-content-itinerary>
    </div>
  </div>
  <hr class="dashed-border">
</div>




<div class="detail-content mt-4" *ngIf="holidayDetails?.accessories?.length">
  <div class="detail-content__section detail-content__info accomodation-tab__terms">
    <app-detail-content-terms [accessories]="holidayDetails?.accessories"></app-detail-content-terms>
  </div>
  <hr class="dashed-border">
</div>

<!-- // GEO SOLUTIONS -->
<ng-container *ngIf="!brand?.detailPageConfig.showPriceGrid && !isLanding">
  <div class="detail-content mt-4 accomodation-tab__occupancy">
    <div class="detail-content__section accomodation-tab__occpancy">
      <detail-occupancy></detail-occupancy>
    </div>
  </div>

  <div class="detail-content mt-4 accomodation-tab__flights" *ngIf="holidayDetails?.hasSolutionsWithFlight">
    <detail-flight></detail-flight>
  </div>
</ng-container>

<div class="wrapper-buttons detail-cta text-center" [ngClass]="{'is-widget' : isWidget}" *ngIf="!isLanding">
  <a class="btn btn--brand-color-03 text-left" dynamicNavigation [href]="bookingUrl">
    <h5>Prosegui</h5>
    <span>verifica disponibilità e prezzo</span>
    <i class="g-icon-chevron-right-circle"></i>
  </a>
</div>


